




import { defineComponent, ref } from '@vue/composition-api';
import Comp from '@/components/Legals/Legals.vue';

export default defineComponent({
  name: 'Legals',
  components: {
    Comp,
  },
});
